import gsap from 'gsap';

function upcoming_events() {
    const upcoming_events_block = document.querySelectorAll('[data-block="upcoming-events"]');
    if (!upcoming_events_block) { return; }

    upcoming_events_block.forEach(block => {
        const filterButtons = block.querySelectorAll('[data-filter]');
        const mobileFilter = block.querySelector('[data-mobile-filter]');
        const eventItems = block.querySelectorAll('[data-event-type]');
        const gridContainer = block.querySelector('.grid');

        // Function to apply filter
        const applyFilter = (filterValue) => {
            const tl = gsap.timeline();

            // First, fade out all items
            tl.to(eventItems, {
                opacity: 0,
                duration: 0.3,
                onComplete: () => {
                    // After fade out, update visibility
                    eventItems.forEach(item => {
                        const itemType = item.getAttribute('data-event-type');
                        if (filterValue === 'all' || filterValue === itemType) {
                            gsap.set(item, { display: 'block', height: 'auto' });
                        } else {
                            gsap.set(item, { display: 'none', height: 0 });
                        }
                    });

                    // Then fade in the visible items
                    gsap.to(eventItems, {
                        opacity: function(i, target) {
                            const itemType = target.getAttribute('data-event-type');
                            return (filterValue === 'all' || filterValue === itemType) ? 1 : 0;
                        },
                        duration: 0.3,
                        stagger: {
                            amount: 0.2,
                            from: "start"
                        }
                    });
                }
            });
        };

        // Desktop filter buttons
        filterButtons.forEach(button => {
            button.addEventListener('click', () => {
                // Remove active class from all buttons
                filterButtons.forEach(btn => btn.classList.remove('actvlist'));
                
                // Add active class to clicked button
                button.classList.add('actvlist');

                const filterValue = button.getAttribute('data-filter');
                
                // Update mobile dropdown to match
                if (mobileFilter) {
                    mobileFilter.value = filterValue;
                }
                
                applyFilter(filterValue);
            });
        });
        
        // Mobile dropdown filter
        if (mobileFilter) {
            mobileFilter.addEventListener('change', () => {
                const filterValue = mobileFilter.value;
                
                // Update desktop buttons to match
                filterButtons.forEach(btn => {
                    if (btn.getAttribute('data-filter') === filterValue) {
                        btn.classList.add('actvlist');
                    } else {
                        btn.classList.remove('actvlist');
                    }
                });
                
                applyFilter(filterValue);
            });
        }
    });
}

export { upcoming_events }; 